import { Link, useLocation, useParams } from "react-router-dom";
import heroImage from "../Static Files/Images/About us/Custom Size.png";
import heroImage2 from "../Static Files/Images/About us/Discount.png";
import joyful1 from "../Static Files/Images/About us/Joyful Image 1.webp";
import joyful2 from "../Static Files/Images/About us/Joyful Image 2.webp";
import airplane from "../Static Files/Images/HomePage/second hero/Aeroplane 64x64.png";
import bestprice from "../Static Files/Images/HomePage/second hero/Best Price 64x64.png";
import employee from "../Static Files/Images/HomePage/second hero/Employee 64x64.png";
import navigation from "../Static Files/Images/HomePage/second hero/Navigation 64x64.png";
import "../Static Files/styles/About Us/aboutus.css";
import translation from "../locales";

const AboutUs = () => {
  const items = Array.from({ length: 50 }, (_, index) => index + 1);
  const location = useLocation();
  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";
  return (
    <>
      <main>
        <section className="aboutus-hero">
          <div className="texts-div">
            <h3>{translation[currentLang].aboutusheroh3}</h3>
            <h1 dangerouslySetInnerHTML={{
                __html: translation[currentLang].aboutusheroh1,
              }}>
            </h1>
            <p className="header-p">
            {translation[currentLang].aboutusheaderp}
            </p>
            <div className="learn-more">
              <a target="_blank" href="https://wa.me/994555074499">
              {translation[currentLang].aboutuslearnmorea}
              </a>
              <div className="phone-number">
                <h2>{translation[currentLang].aboutusformoreinformation}</h2>
                <p>(+99455) 507 44 99</p>
              </div>
            </div>
          </div>
          <img src={heroImage} alt="background-image" />
          <img
            className="responsive-img"
            src={heroImage2}
            alt="background-image"
          />
        </section>

        <section className="aboutus-features-section">
          <div className="cards-div">
            <ul>
              <li>
                <div className="features-card">
                  <img src={airplane} alt="" />
                  <h5>24,000</h5>
                  <p>
                    Beyond Borders: A Journey Through the Most Breathtaking
                    Destinations on Earth
                  </p>
                </div>
              </li>
              <li>
                <div className="features-card">
                  <img src={navigation} alt="" />
                  <h5>55+</h5>
                  <p>
                    Countries, Endless Adventures: Explore the World’s Hidden
                    Gems
                  </p>
                </div>
              </li>
              <li>
                <div className="features-card">
                  <img src={bestprice} alt="" />
                  <h5>Best Price</h5>
                  <p>
                    Experience More for Less with Unbeatable Deals and Exclusive
                    Discounts
                  </p>
                </div>
              </li>
              <li>
                <div className="features-card">
                  <img src={employee} alt="" />
                  <h5>84 Million+</h5>
                  <p>
                    Embark on Unforgettable Journeys with Exclusive Deals and
                    Unique Experiences
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="texts-div">
            <h1>{translation[currentLang].aboutustextdivh1}</h1>
            <p  dangerouslySetInnerHTML={{
                __html: translation[currentLang].aboutustextdivp,
              }}>
            </p>
            <Link to={lang === "az" ? `/az/tours` : `/en/tours`}>{translation[currentLang].aboutustextdiva}</Link>
          </div>
        </section>

        <section className="company-information-section">
          <div className="dotList">
            <ul>
              {items.map((item) => (
                <li key={item}>
                  <div className="dot"></div>
                </li>
              ))}
            </ul>
          </div>
          <div className="dotList dotbottom">
            <ul>
              {items.map((item) => (
                <li key={item}>
                  <div className="dot"></div>
                </li>
              ))}
            </ul>
          </div>
          <div className="top-texts">
            <img src={joyful1} alt="img1" />
            <div className="description-div">
              <h1>{translation[currentLang].aboutuscompanyinfoh1}</h1>
              <p>
              {translation[currentLang].aboutuscompanyinfop1}
              </p>
            </div>
          </div>
          <div className="bottom-texts">
            <div className="description-div">
              <p  dangerouslySetInnerHTML={{
                __html: translation[currentLang].aboutuscompanyinfop2,
              }}>
              </p>
            </div>
            <img src={joyful2} alt="img1" />
          </div>
        </section>
      </main>
    </>
  );
};

export default AboutUs;
